import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

const useHankoAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error('useHankoAuth must be used within AuthProvider');
    }
    return ctx;
};

export default useHankoAuth;
